import React, { useEffect, useRef, useState } from "react";
import "./HereToMakeItEasy.scss";
import DownChevron from "../../images/down-chevron.svg";
const HereToMakeItEasy = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((content, i) => {
      if (content) {
        if (i === activeIndex) {
          content.style.maxHeight = `${content.scrollHeight}px`; // Expand to full height
        } else {
          content.style.maxHeight = "0"; // Collapse smoothly
        }
      }
    });
  }, [activeIndex]);

  const accordionData = [
    {
      question: "How do I subscribe to MYBYK?",
      answer:
        "Subscribing is super simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby hub or choose home delivery (available in select areas).",
    },
    {
      question: "Where can I pick up and drop off MYBYK bicycles?",
      answer:
        "You can pick up a bike from any MYBYK hub in Ahmedabad and drop it off at any other hub for your convenience. Plus, you can swap bicycles at any BRTS station (75+ MYBYK hubs) to enjoy seamless first and last-mile connectivity.",
    },
    {
      question: "What type of bicycles does MYBYK provide?",
      answer:
        "MYBYK offers high-quality pedal cycles built for daily commuting and city exploration. They are lightweight, durable, and perfect for rides of any length.",
    },

    {
      question: "Are MYBYK bicycles available near Metro and BRTS stations?",
      answer:
        "Absolutely! MYBYK hubs are conveniently located near major Metro and BRTS stations, making your travel smooth and efficient.",
    },
    {
      question: "What happens if the bicycle gets damaged?",
      answer:
        "No worries! If the bicycle is damaged, visit your nearest MYBYK hub and swap it for a replacement with your existing subscription at no extra cost.",
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer:
        "Yes, you can! Just return the bike to your nearest MYBYK hub, and your subscription will be canceled with no hassle.",
    },
  ];
  return (
    <section className="faq section-padding-lg">
      <div className="container">
        <div className="faq-accordion">
          <div className="faq-accordion-details section-header">
            <h2>
              We’re here <span>to make it easy!</span>
            </h2>
          </div>
          {accordionData.map((item, index) => (
            <div
              className={`accordion-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="accordion-label"
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-question">{item.question}</span>
                <span className="icon">
                  <figure>
                    <img src={DownChevron} alt="chevron-arrow" loading="lazy" />
                  </figure>
                </span>
              </div>
              <div
                className="accordion-content"
                ref={(el) => (contentRefs.current[index] = el)}
                style={{
                  overflow: "hidden",
                  transition: "max-height 0.5s ease",
                }}
              >
                <p>{item.answer}</p>
                {/* <br /> to add some space below paragraph */}
                <br />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HereToMakeItEasy;
